import { chakra, Stack } from "@chakra-ui/react"

const ContentBox = chakra(Stack, {
  baseStyle: {
    textAlign: "center",
    alignItems: "center",
    bg: "brand.navy.light",
    rowGap: 1,
  },
})

export const ContentBoxMobile = chakra(ContentBox, {
  baseStyle: {
    pt: 3,
    pb: 6,
    px: 5,
  },
})

export const ContentBoxDesktop = chakra(ContentBox, {
  baseStyle: {
    position: "absolute",
    py: 2.5,
    px: 4,
    top: "50%",
    left: "85%",
    transform: "translate(-85%, -50%)",
    w: "425px",
    borderRadius: "sm",
  },
})
